var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("date-filter", { attrs: { namespace: _vm.namespace } }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { lg: "6" } },
            [_c("worker-filter", { attrs: { namespace: _vm.namespace } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            [
              _c("group-by-date-filter", {
                attrs: { namespace: _vm.namespace }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading ? _c("b-spinner", { staticClass: "mb-2 ml-3" }) : _vm._e(),
      _vm._v(" "),
      _c("MotivateCookerTableStats", {
        attrs: { loading: _vm.loading, namespace: _vm.namespace }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-144f49f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-144f49f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MotivateCookStats.vue
// module id = null
// module chunks = 